import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebSelectTextSquare({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [answer, setAnswer] = useState([]);


    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(data.choices);
        setAnswer([]);
    }, [question,
        data.choices,
    ]);

    const handleClickChoice = (choice) => {
        let ans = [...answer];
        if (!data.multiple) {
            ans = []; // reset for string
        }

        ans = [
            ...ans,
            choice.stateKey
        ];
        
        setAnswer(ans);
        checkCanProceed(ans);
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    return (
        <Box
            sx={{
                position: "relative",
                fontSize: "24px"  
            }}
        >
            <Box component="img"
                src={`${imagesResources}${data.image}`}
                sx={{
                    position: "absolute",
                    top: "135px",
                    left: "325px",
                }}
                alt="Drive Car Img"
            />

            {/* For Choices */}
            <Box sx={{
                width: "1050px",
                height: "600px",
                fontSize: "24px",
                textAlign: "center",
            }}>
                <Box sx={{
                    display: "block",
                    width: "1400px",
                    fontSize: "24px",
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index}
                            component="span"
                            sx={{
                                width: "350px",
                                height: "100px",
                                fontWeight: "normal",
                                marginRight: "344px",
                                marginBottom: "345px",
                                display: "inline-table",
                                cursor: "pointer",
                                userSelect: "none",
                                backgroundColor: answer.includes(choice.stateKey) ? "#afe23e" : "#dadada",
                                borderBottom: answer.includes(choice.stateKey) ? "10px solid #639729" : "10px solid #808080",
                                fontSize: "24px",
                                textAlign: "center",
                            }}
                            onClick={() => {handleClickChoice(choice)}}
                        >
                            <Box component="span"
                                sx={{
                                    display: "table-cell",
                                    verticalAlign: "middle",
                                }}
                            >
                                {choice.children.map((row, rowIndex) => {
                                    const Tag = row.type;
                                    return (
                                        <React.Fragment key={rowIndex}>
                                            <Tag>{row.value}</Tag>
                                        </React.Fragment>
                                    )
                                })}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};